import {observer} from 'mobx-react';
import RecruitingSubnav from 'main/containers/recruiting/components/RecruitingSubnav';
import InterviewScheduleDirectoryWithState from 'main/containers/recruiting/components/interview_schedules/directory/components/InterviewScheduleDirectoryWithState';

const InterviewScheduleDirectory = observer(({history}) => {
  return (
    <div>
      <RecruitingSubnav/>
      <InterviewScheduleDirectoryWithState history={history}/>
    </div>
  );
});

export default InterviewScheduleDirectory;
